import { List, Record } from "immutable";

import preprocessorQuery from "../../../utils/preprocessorQuery";
import createFromJS from "../../createFromJS";

const isIos = preprocessorQuery.isIos();
// const isReadonly = preprocessorQuery.isReadonly();

const defaultIsVisibleValue = !isIos; // && !isReadonly;

export const WelcomeScreenRecord = Record({
  isVisible: defaultIsVisibleValue,
  showTemplateWizard: false,
  showUpgradeWizard: false,
  showLoadingFile: false,
  incomingUpgradeData: null,
  recentFiles: List(),
  exampleFiles: List(),
  customTemplates: List()
});

const data = {
  collections: {
    recentFiles: "FileRecord",
    exampleFiles: "FileRecord",
    customTemplates: "WelcomeTemplateRecord"
  }
};

createFromJS.registerCallback("WelcomeScreenRecord", createFromJS.createNestedCallback(WelcomeScreenRecord, data));
